import React, {type ReactNode} from 'react';

import {SPPage} from 'app/general/structures/SPPage';
import {VideoManagerProvider} from 'app/general/VideoManagerProvider';
import {getTemplateName} from 'app/utils/fallbacks';

import {TransferTemplateButton} from './TransferTemplateButton';

import {useTemplateByHashid} from '../api';
import {TemplateContext} from '../context';
import {TemplateRouterParams} from '../types';

interface Props {
  params: TemplateRouterParams;
  children: ReactNode;
}

export function TemplateDetailPage({params, children}: Props) {
  const {data: template} = useTemplateByHashid(params.hashid);

  if (template == null) {
    return null;
  }

  return (
    <SPPage
      pageTitle={getTemplateName(template)}
      horizontalPadding={false}
      breadcrumbProps={{
        docName: getTemplateName(template),
      }}
      actionArea={<TransferTemplateButton template={template} />}
    >
      <TemplateContext.Provider value={template}>
        <VideoManagerProvider>{children}</VideoManagerProvider>
      </TemplateContext.Provider>
    </SPPage>
  );
}
